import { render } from "./App.vue?vue&type=template&id=1f7f48f8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1f7f48f8&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.18+webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__